import { FilterTypesEnum } from '../FilterTypesEnum';
import { FilterModel } from './filter.model';

export class NumberSmallerFilterModel extends FilterModel {
  override symbol: FilterTypesEnum = FilterTypesEnum.num_smaller;

  isValid() {
    return !!this.value;
  }
}
